const BASE_IMAGE_URL = 'https://media.rawg.io/media'
const CROP_IMAGE_PATH = '/crop/600/400'
const CROP_IMAGE_URL = 'https://media.rawg.io/media/crop/600/400'
const BASE_API_URL = 'https://api.rawg.io/api/'
const GAMES_API_URL = 'https://api.rawg.io/api/games'
const API_KEY_PARAM = 'key='+process.env.REACT_APP_API_KEY

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  BASE_IMAGE_URL,
  CROP_IMAGE_PATH,
  CROP_IMAGE_URL,
  BASE_API_URL,
  GAMES_API_URL,
  API_KEY_PARAM
}